// components/timesheet/TimesheetFilters.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker';

const TimesheetFilters = ({
  filter,
  setFilter,
  employeeOptions,
  selectedEmployee,
  setSelectedEmployee,
  handleDateChange,
  handleReset,
  isLoading
}) => {
  const { t } = useTranslation();

  const handleEmployeeChange = (selectedOptions) => {
    setSelectedEmployee(selectedOptions);
    const employeeIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    const employeeIdParam = employeeIds.length > 0 ? employeeIds.join(",") : "";
    setFilter({ ...filter, employeeId: employeeIdParam });
  };

  return (
    <div className="border-b border-gray-200 px-4 py-3">
      <div className="flex flex-wrap items-center gap-3">
        {/* Status Dropdown */}
        <select
          value={filter.status}
          onChange={(e) => setFilter({ ...filter, status: e.target.value })}
          className="block px-2 py-3 text-sm text-gray-600 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option key='draft' value="draft">{t("DRAFT")}</option>
          <option key='submitted' value="submitted">{t("PENDING_APPROVAL")}</option>
          <option key='approved' value="approved">{t("APPROVED")}</option>
          <option key='rejected' value="rejected">{t("REJECTED")}</option>
          <option key='all' value="">{t("ALL")}</option>
        </select>

        {/* Employee Select */}
        <div className="w-[200px]">
          <Select
            isMulti
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                minHeight: "38px",
                height: "auto",
                borderRadius: "0.5rem",
                border: "1px solid rgb(209, 213, 219)",
                color: "#000",
                fontSize: "0.875rem",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                padding: "2px 8px",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                margin: "0px",
              }),
              indicatorsContainer: (baseStyles) => ({
                ...baseStyles,
                height: "38px",
              }),
            }}
            options={employeeOptions}
            value={selectedEmployee}
            placeholder={t("All")}
            isClearable
            onChange={handleEmployeeChange}
            className="basic-multi-select"
            classNamePrefix="select"
          />
        </div>

        {/* Date Range Picker - Pass startDate and endDate from filter */}
        <div className="pt-3 flex items-center gap-2">
          <ODateRangePicker
            handleDateChange={handleDateChange}
            isReset={filter.isReset || false}
            setIsReset={(value) => setFilter({ ...filter, isReset: value })}
            startDate={filter.startDate}
            endDate={filter.endDate}
          />
        </div>

        {/* Reset Button */}
        <button
          onClick={handleReset}
          className="px-4 py-2 text-sm text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200"
        >
          {t("RESET")}
        </button>
      </div>
    </div>
  );
};

export default TimesheetFilters;